import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const removeSectionTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  onExit: assign<Context>({ selectedSectionId: null }),
  invoke: {
    src: "removeSection",
    onDone: {
      target: "#StudyPlan.edit_plan.idle",
      actions: assign((ctx, evt) => {
        return {
          studyPlan: evt.data.plan,
          // Collapse deleted section.
          expanded: ctx.expanded.filter(
            id => !evt.data.plan.sections.find(sectionId => sectionId === id)
          )
        }
      })
    },
    onError: {
      target: "idle",
      actions: assign({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("removeSection", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
